import {convertIsoToPersian, options, timeOptions, yearOptions,time12hOptions} from "../../../helpers/Functions";
export function dataStructureGridTable(data, filterChoice) {
    let gridData = [];
    // from friday to saturday 0->6
    let array06 = [[], [], [], [], [], [], []];
    let array69 = [[], [], [], [], [], [], []];
    let array912 = [[], [], [], [], [], [], []];
    let array1215 = [[], [], [], [], [], [], []];
    let array1518 = [[], [], [], [], [], [], []];
    let array1821 = [[], [], [], [], [], [], []];
    let array2124 = [[], [], [], [], [], [], []];
    let filterData = data?.gridData;
    if (parseInt(filterChoice) !== 3) {
        filterData = data?.gridData.filter(item => {
            return item?.glucoseStatus === filterChoice;
        });
    }
    filterData?.reverse().map((item) => {
        let Time = item.estimatedDate.match(/\d\d:\d\d/);
        let hour = parseInt(Time[0].slice(0, 2));
        if (hour >= 0 && hour < 6) {
            array06[item.dayOfWeek].push([item.testResult.toString(), item.glucoseStatus]);
        } else if (hour >= 6 && hour < 9) {
            array69[item.dayOfWeek].push([item.testResult.toString(), item.glucoseStatus]);
        } else if (hour >= 9 && hour < 12) {
            array912[item.dayOfWeek].push([item.testResult.toString(), item.glucoseStatus]);
        } else if (hour >= 12 && hour < 15) {
            array1215[item.dayOfWeek].push([item.testResult.toString(), item.glucoseStatus]);
        } else if (hour >= 15 && hour < 18) {
            array1518[item.dayOfWeek].push([item.testResult.toString(), item.glucoseStatus]);
        } else if (hour >= 18 && hour < 21) {
            array1821[item.dayOfWeek].push([item.testResult.toString(), item.glucoseStatus]);
        } else if (hour >= 21 && hour < 24) {
            array2124[item.dayOfWeek].push([item.testResult.toString(), item.glucoseStatus]);
        }
    });
    let days = ['جمعه', 'پنجشنبه','چهارشنبه', 'سه‌شنبه','دوشنبه','یکشنبه','شنبه']
    for (let i=6 ;i>=0; i--){
        gridData.push([...[days[i], array06[i], array69[i], array912[i],
            array1215[i], array1518[i], array1821[i], array2124[i]]]);
    }
    const {dateFrom, dateTo} = calculateFromTo(data.from, data.to);
    return ({data: gridData, from: dateFrom, to: dateTo});

}

const calculateFromTo = (from, to) => {
    //api return last week a day more so we minus that
    let friday = new Date(to);
    friday.setDate(friday.getDate() - 1);
    const dateTo = convertIsoToPersian(friday);
    const dateFrom = convertIsoToPersian(from);
    console.log(dateTo, dateFrom)
    return {dateFrom, dateTo};
};

export function dataFilterListTable(data, filterChoice) {
    let finalObj = Object.assign({}, data);

    let filteredData = finalObj?.pages.map((page) => {
        let filterData = page;
        // filter data by (high inRange low) filter
        if (parseInt(filterChoice) !== 3) {
            filterData = page.filter(item => {
                return item?.glucoseStatus === filterChoice;
            });
        }
        return filterData
    })
    Object.keys(finalObj).map(key => key === 'pages' ? finalObj[key] = filteredData : '')
    return finalObj
}

export const destructureDataForModalCards = (cardData) => {
    const id = cardData?.id;
    let weekday, dateNumeric, time;
    if (cardData?.dateNumeric) {
        weekday = cardData?.dateNumeric?.fullDateLong;
        dateNumeric = cardData?.dateNumeric?.numericDate;
        time = cardData?.time;
    } else {
        const timestamp = new Date(cardData?.estimatedDate);
        // year date 1400/1/1
        dateNumeric = new Intl.DateTimeFormat('fa-IR', yearOptions).format(
            timestamp
        );
        // hour
        time = new Intl.DateTimeFormat('en-IR', time12hOptions).format(
            timestamp
        );
        // weekday   => دوشنبه 5 مهر
        weekday = new Intl.DateTimeFormat('fa-IR', options).format(
            timestamp
        );
    }

    // suger result
    const testResult = cardData?.testResult;
    // mealStatus => postmeal/premeal/unknown
    const mealStatus = cardData?.mealStatus;
    // glocouse status => high/ inRange / Low
    const glucoseStatus = cardData?.glucoseStatus;
    const jalaliDate = cardData?.jalaliDate;

    return {id, testResult, glucoseStatus, time, mealStatus, jalaliDate, dateNumeric, weekday};

};
